"use client";

import { Trans } from "@lingui/react/macro";
import { HistoryIcon } from "lucide-react";
import { type ReactNode, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

type Props = {
  list: ReactNode;
};

/**
 * モバイル用のチャット履歴表示ボタン＋ダイアログ
 */
export function MobileChatListButton({ list }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        onClick={() => setOpen(true)}
        className="md:hidden"
        size="icon"
        variant="ghost"
      >
        <span className="sr-only">
          <Trans>Open chat list</Trans>
        </span>
        <HistoryIcon />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          onClose={() => setOpen(false)}
          className="px-0 py-3 flex max-h-[80vh] overflow-hidden"
        >
          <DialogTitle className="sr-only">
            <Trans>Chats</Trans>
          </DialogTitle>
          {list}
        </DialogContent>
      </Dialog>
    </>
  );
}
